var MpPageBulletinAdvert;

(function() {
    if (!document.querySelector('#vue-body-bulletin-advert')) {
        return;
    }

    MpPageBulletinAdvert = new Vue({
        el: '#vue-body-bulletin-advert',
        data: {
            CONTACT_COUNTER_URL: '/bulletin/incrementContactAttemps',
            ADVERT_ID: advertId, // Comes from PHP BulletinController

            carousel: null,

            // Comes from PHP BulletinController

            advertCategories: JSON.parse(advertCategories),
            equipmentCategoryFullList: JSON.parse(equipmentCategoryFullList),

            isContactShown: false,
            isInitialized: false,
        },

        computed: {

        },

        methods: {

            initSwiper: function() {

                this.carousel = new Swiper(this.$refs.carousel, {
                    autoHeight: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
            },

            showContactInfo: function() {
                this.isContactShown = true;

                axios.post(this.CONTACT_COUNTER_URL, Serializer.serialize({
                    'advertId': this.ADVERT_ID,
                }));
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;

                if (this.$refs.carousel) {
                    this.initSwiper();
                }
            },
        },

        filters: {},

        mounted: function() {

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },
    });

})();
